import axios from "axios"
// if(process.env.VUE_APP_BASE_URL && process.env.VUE_APP_ENVIRONEMENT === 'development') {
//   // axios.defaults.baseURL = "https://apifcintellilink.intellibees.in/api" 
//    axios.defaults.baseURL = "http://localhost:3001/api";
// } else {
//   axios.defaults.baseURL = "https://apifcintellilink.intellibees.in/api";
// }
// console.log(axios.defaults.baseURL, "api uri")
// let userdata = localStorage.getItem('userdata');
// if(userdata) {
//   userdata = JSON.parse(userdata)
//   const AUTH_TOKEN = localStorage.getItem("token")
//   axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
//   // axios.defaults.headers.common["useremail"] = userdata.username;
//   // axios.defaults.headers.common["empcode"] = userdata.userid;
//   // axios.defaults.headers.common["empid"] = userdata.employeeid;
//   axios.defaults.headers.post["Content-Type"] = "application/json";
// }

// export default axios;

// import axios from "axios";

const sendRequest = () => {
  axios.interceptors.request.use(
    (config) => {
      let user = JSON.parse(localStorage.getItem("userdata"));
      // console.log(user, "++++++")

      const AUTH_TOKEN = user?.accessToken;
      config.baseURL = "https://apiintellilink.intellibees.in/api2";
      // config.baseURL = "http://localhost:3003/api2";

      if (AUTH_TOKEN) config.headers.authorization = AUTH_TOKEN;
      else config.headers.authorization = "";
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return axios;
};

export default sendRequest();
